import React from 'react'
import { ProgressBar } from 'react-bootstrap'
import { humanReadableByteCount } from './../../lib/helper'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

class WPEngineStats extends React.Component {
	render() {
		const { migrate, cancel, progress } = this.props
		return <div className="wpe">
			<div className="migration-loading-page">
				<div className="container">
					<div className="row align-items-center mb-2">
						<div className="col-sm-12 d-flex justify-content-center">
							<img width="500" height="200" src="/assets/wpengine/blogvault-logo-black.svg" alt="blogvault-logo"/>
						</div>
					</div>
					<div className="row align-items-center mb-2">
						<div className="col-sm-12" style={{lineHeight: '1.5'}}>
							<p className="text-center">
								Migrating <a href={migrate.get('source_site')} target="_blank" rel="noopener noreferrer">{migrate.get('source_site')}</a> to
								{' '}<a href={migrate.get('destination_site')} target="_blank" rel="noopener noreferrer">{migrate.get('destination_site')}</a><br/>
								You may leave this page at any time.
							</p>
						</div>
					</div>
					<div className="row justify-content-center mb-2">
						<div className="v-center" style={{flexDirection: 'column'}}>
							<div className="progress-group">
								<p className="progress-label font14">{ humanReadableByteCount(migrate.getIn(['status', 'files', 'size', 'synced'])) }/{ humanReadableByteCount(migrate.getIn(['status', 'files', 'size', 'total']) - migrate.getIn(['status', 'files', 'size', 'ignored'])) } - Files</p>
								<ProgressBar now={migrate.getIn(['status', 'files_progress'])}/>
							</div>
							<div className="progress-group">
								<p className="progress-label font14">{ migrate.getIn(['status', 'database', 'synced']) }/{ migrate.getIn(['status', 'database', 'total']) - migrate.getIn(['status', 'database', 'ignored']) } - Tables</p>
								<ProgressBar bsStyle="success" now={migrate.getIn(['status', 'tables_progress'])} />
							</div>
							<div className="progress-group">
								<p className="progress-label font14">Site Migrations {progress}%</p>
								<ProgressBar bsStyle="info" now={progress}/>
							</div>
						</div>
					</div>
					<div className="row justify-content-center">
						<div className="col-sm-4 d-flex justify-content-center float-none margin-auto">
							<button className="button secondary-button" onClick={() => cancel()}>Cancel Migration</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
}

WPEngineStats.propTypes = {
	migrate: ImmutablePropTypes.map,
	cancel: PropTypes.func,
	progress: PropTypes.number
}

export default WPEngineStats
